import Dialog from './Dialog'
import { build, commitID, environmentName, getElectricalCodeName } from '../App.config'
import { useModuleContext } from '../contexts/ModuleContext'
import { FC } from 'react'

type Props = {
    visible: boolean
    onHide: Function
}

export const AboutDialog: FC<Props> = ({ visible, onHide }: Props) => {
    const { user: { userName, userId, companyId, companyName, electricalCode } } = useModuleContext()
    const dialogBody = `
            Environment: ${environmentName}<br>
            Build: ${build}<br>
            Commit: ${commitID}<br>
            Student: ${userName} (${userId})<br>
            Company: ${companyName} (${companyId})<br>
            EC: ${getElectricalCodeName(electricalCode)}
        `

    return (
        <Dialog
            title={'About'}
            body={dialogBody}
            show={visible}
            onHide={onHide} />
    )
}
